<script setup lang="ts">
const { sidebarElements } = useSidebar();
</script>

<template>
  <div class="flex min-h-screen bg-gray-50 dark:bg-gray-900">
    <AppSidebar
      :elements="sidebarElements"
      class="w-64"
    />

    <main
      class="flex-1"
    >
      <UContainer
        :ui="{ width: 'max-w-none' }"
        class="h-full px-4 py-4"
      >
        <slot />
      </UContainer>
    </main>
  </div>
</template>
